/**
 * @copyright 2025 Cooltrax Pty Ltd. All rights reserved.
 */

import { Outlet } from 'react-router-dom'

/**
 * The nav, its providers and the scrolling content area now live in the app-wide Layout, so
 * every route gets the same shell. Kept as the element of the app routes for now.
 */
const DashboardLayout = () => <Outlet />

export default DashboardLayout
